import React from "react";
import SearchInput from "@/components/SearchInput/SearchInput";
import { ChipFilterGroup } from "@/components/ChipFilterGroup/ChipFilterGroup";
import { DatePicker } from "@/components/DatePicker/DatePicker";
import { useOrderListFilters } from "../../hooks/useOrderListFilters";
import {
  OrderListFilters as OrderFilters,
  useOrderListPage,
} from "../../hooks/useOrderListPage";

interface OrderListFiltersProps {
  filters: OrderFilters;
  onFiltersChange: ReturnType<typeof useOrderListPage>["handleFiltersChange"];
}

const OrderListFilters: React.FC<OrderListFiltersProps> = ({
  filters,
  onFiltersChange,
}) => {
  const {
    filterConfigs,
    filterValues,
    handleChipChange,
    handleClearAll,
    hasActiveFilters,
    searchTerm,
    onSearchChange,
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
    searchPlaceholder,
  } = useOrderListFilters({ filters, onFiltersChange });

  return (
    <div className="mb-4 flex flex-col gap-3">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        <div className="flex-1">
          <SearchInput
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
            value={searchTerm}
          />
        </div>
        <ChipFilterGroup
          filters={filterConfigs}
          onChange={handleChipChange}
          onClearAll={handleClearAll}
          showActiveFilters={false}
          showChips={true}
          values={filterValues}
        />
        <div className="w-44 [&>button]:!border-gray-200 dark:[&>button]:!border-white/20 [&>button]:font-medium [&>button]:!text-gray-600 dark:[&>button]:!text-white">
          <DatePicker
            onChange={onStartDateChange}
            placeholder="Start Date"
            value={startDate}
          />
        </div>
        <div className="w-44 [&>button]:!border-gray-200 dark:[&>button]:!border-white/20 [&>button]:font-medium [&>button]:!text-gray-600 dark:[&>button]:!text-white">
          <DatePicker
            onChange={onEndDateChange}
            placeholder="End Date"
            value={endDate}
          />
        </div>
      </div>
      {hasActiveFilters && (
        <div className="rounded-lg border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 py-3 [&>div]:!border-t-0 [&>div]:!mt-0 [&>div]:!pt-0">
          <ChipFilterGroup
            filters={filterConfigs}
            onChange={handleChipChange}
            onClearAll={handleClearAll}
            showActiveFilters={true}
            showChips={false}
            values={filterValues}
          />
        </div>
      )}
    </div>
  );
};

export default OrderListFilters;
